import React, { Fragment } from "react";
import GroupCard from "../group-card";
import { Container, Divider } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import NotFoundMessage from "../not-found-message";
import StyledUserList from "./styles";

const GroupList = ({ groups, onGroupClick }) => {
  if (!groups || !Array.isArray(groups)) return null;

  return (
    <StyledUserList>
      <Container maxWidth="md" className="group-list-container">
        <div className="group-container">
          {groups.length > 0 ? (
            groups.map((data, i) => (
              <Fragment key={`item-${i}`}>
                <GroupCard {...data} onUserClick={onGroupClick} />
                {i !== groups.length - 1 && (
                  <div className="group-divider">
                    <Divider />
                  </div>
                )}
              </Fragment>
            ))
          ) : (
            <NotFoundMessage
              message="Hmmmm....     Parece que no hay resultados para tu búsqueda"
              Icon={SearchIcon}
            />
          )}
        </div>
      </Container>
    </StyledUserList>
  );
};

export default GroupList;
